namespace e5 {
    export class ObjectUtil {
        public static extend<Value = any>(target: any | Value, ...objects: Value[]): Value {
            for (var i = 0; i < objects.length; i++)
                for (var key in objects[i])
                    if (objects[i] && objects[i].hasOwnProperty(key)) {
                        if (this.isObjectLiteral(target[key])
                            && this.isObjectLiteral(objects[i][key])) {
                            ObjectUtil.extend(target[key], objects[i][key]);
                        }
                        else
                        target[key] = objects[i][key];
                    }
            return target;
        }

        public static isObjectLiteral(o: any): boolean {
            if (!o)
                return false;

            if (!o.constructor)
                return false;

            if (o.constructor === Object)
                return true;

            // if (typeof o === 'object' && o.__proto__ === Object.prototype)
            //     return true;

            //@source https://stackoverflow.com/questions/4320767/check-that-value-is-object-literal
            // if( Object.prototype.toString.call( o ) === '[object Object]' ) {
            //     return true;
            // }

            return false;
        }

        public static isNumber(v: any): v is number {
            return typeof v === "number";
        }

        public static fallback(...items: any[]): any {
            for (var i = 0; i < items.length; ++i) {
                if (items[i])
                    return items[i];
            }
            return null;
        }
    }
}